// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./assets/animation.less
// module id = 95
// module chunks = 0